import React from "react";
import {
  Container,
  Paper,
  Grid,
  Stack,
  Avatar,
  Typography,
  alpha,
  useTheme,
} from "@mui/material";
import { motion } from "framer-motion";

export default function StatsSct({ stats = [] }) {
  const theme = useTheme();

  return (
    <Container maxWidth="lg" sx={{ mt: -4, position: "relative", zIndex: 3 }}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.5 }}
      >
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, md: 4 },
            borderRadius: 1,
            bgcolor: "transparent",
            boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
            border: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
          }}
        >
          <Grid container spacing={2}>
            {stats.map((stat, idx) => (
              <Grid size={{ xs: 6, md: 3 }} key={idx}>
                <Stack alignItems="center" gap={2}>
                  <Avatar
                    sx={{
                      bgcolor: alpha(theme.palette.primary.main, 0.08),
                      color: theme.palette.primary.main,
                      width: 44,
                      height: 44,
                      borderRadius: 4,
                    }}
                  >
                    {stat.icon}
                  </Avatar>
                  <Typography
                    variant="h4"
                    fontWeight={800}
                    color="text.primary"
                    fontSize="1.2rem"
                  >
                    {stat.value}
                  </Typography>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    fontWeight={500}
                    fontSize="0.8rem"
                  >
                    {stat.label}
                  </Typography>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Paper>
      </motion.div>
    </Container>
  );
}